import * as t from "io-ts"

// Address spec
const SingleAddressSuggestion = t.type({
    Text: t.string,
})

const AddressSuggestionResults = t.array(SingleAddressSuggestion)

export const AddressSuggestion = t.type({
    Results: AddressSuggestionResults,
})

export type IAddressSuggestion = t.TypeOf<typeof AddressSuggestion>
export type IAddressSuggestionResults = t.TypeOf<
    typeof AddressSuggestionResults
>

export interface IPlaces {
    [key: string]: IAddressSuggestion
}
